var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/layout/Overlay.tsx";
import classnames from 'classnames';
import { downcastRef } from '../../util/typing';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * A full-screen fixed backdrop overlay
 */
export default function Overlay({
  children,
  classes,
  elementRef,
  open = true,
  variant = 'dark',
  ...htmlAttributes
}) {
  if (!open) {
    return null;
  }
  return _jsxDEV("div", {
    "data-component": "Overlay",
    ...htmlAttributes,
    ref: downcastRef(elementRef),
    className: classnames('fixed top-0 left-0 w-full h-full z-10 flex items-center justify-center', {
      'bg-black/50': variant === 'dark',
      // default
      'bg-white/50': variant === 'light'
    }, classes),
    children: children
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 35,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=Overlay.js.map